import { UnableToStartCheckoutAbTestReason } from "@redotech/redo-model/checkouts/checkout-ab-test-utils";
import * as z from "zod/v4";

export const canStartCheckoutAbTest = {
  name: "canStartCheckoutAbTest" as const,
  input: z.null(),
  output: z.union([
    z.object({ canStart: z.literal(true) }),
    z.object({
      canStart: z.literal(false),
      reason: z.enum(UnableToStartCheckoutAbTestReason),
    }),
  ]),
};
export type CanStartCheckoutAbTestOutput = z.infer<
  typeof canStartCheckoutAbTest.output
>;
